export default "__VITE_PUBLIC_ASSET__5ea659da__"